<template>
  <div class="status-ribbon" :class="statusClass">
    <span class="status-ribbon-text">{{ statusText }}</span>
  </div>
</template>

<script>
import { ORDER_STATUS_TEXT, ORDER_STATUS_CLASS } from "@/consts/proPlan";

/**
 * 订单状态角标（右上角旗形，形状取自设计稿，颜色随状态变化）
 */
export default {
  name: "StatusRibbon",
  props: {
    status: {
      type: [Number, String],
      required: true,
    },
  },
  computed: {
    statusText() {
      return ORDER_STATUS_TEXT[this.status] || "";
    },
    statusClass() {
      return ORDER_STATUS_CLASS[this.status] || "";
    },
  },
};
</script>

<style lang="scss" scoped>
// 旗形形状用 SVG 作 mask，颜色由 background 提供，便于按状态换色
.status-ribbon {
  position: absolute;
  top: 0;
  right: 0;
  width: 80px;
  height: 41px;
  z-index: 2;
  -webkit-mask-image: url("~@/assets/images/pro-plan/plan/order-ribbon-mask.png");
  mask-image: url("~@/assets/images/pro-plan/plan/order-ribbon-mask.png");
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-size: 100% 100%;
  mask-size: 100% 100%;
  color: #fff;
  // 待支付 / 退款中：实色底 + 白字
  &.ribbon-unpaid,
  &.ribbon-refunding {
    color: #fff;
  }
  // 退款失败：设计稿（节点 2266:497）为**浅灰渐变底 + 灰蓝字**，
  // 与「已取消」同一套色（fill_37d2a33a）——并非红底白字（禅道 #23493：颜色与设计稿不一致）。
  // 形状也不同：容器 90×41、旗形 86×30（更扁平，右侧「尾巴」短），
  // 故用设计稿形状单独做的遮罩，而非复用 80×41 的那张（压扁会得到错误的旗角）。
  // 文字框按设计稿 x=28 宽 56（4 字 × 14px 需 56px，原先 42px 装不下 → 「文字好挤」）。
  &.ribbon-refund-failed {
    width: 90px;
    color: #62717e;
    background: linear-gradient(
      270deg,
      rgba(98, 113, 126, 0.28) 0%,
      rgba(118, 134, 163, 0.28) 39%,
      rgba(187, 199, 220, 0.28) 71%
    );
    -webkit-mask-image: url("~@/assets/images/pro-plan/plan/order-ribbon-mask-refund-failed.svg");
    mask-image: url("~@/assets/images/pro-plan/plan/order-ribbon-mask-refund-failed.svg");
    .status-ribbon-text {
      left: 28px;
      width: 56px;
    }
  }
  // 已支付 / 已取消 / 已退款：浅色渐变底 + 彩色字
  // 渐变方向按设计稿 SVG 的 x1=80 → x2=9（**从右往左**）：浅色在右、深色在左。
  // 原先写的 90deg 是「左→右」，方向正好相反（禅道 #23493-1）。
  // 用 270deg（= 从右往左）与其等价。
  &.ribbon-paid {
    color: #0fa87b;
    background: linear-gradient(
      270deg,
      rgba(15, 168, 123, 0.28) 0%,
      rgba(43, 208, 114, 0.28) 38%,
      rgba(96, 215, 152, 0.28) 89%
    );
  }
  &.ribbon-canceled {
    color: #62717e;
    background: linear-gradient(
      270deg,
      rgba(98, 113, 126, 0.28) 0%,
      rgba(118, 134, 163, 0.28) 39%,
      rgba(187, 199, 220, 0.28) 71%
    );
  }
  &.ribbon-refunded {
    color: #ff4f4f;
    background: linear-gradient(
      270deg,
      rgba(255, 21, 25, 0.23) 0%,
      rgba(255, 82, 82, 0.23) 43%,
      rgba(255, 112, 34, 0.23) 89%
    );
  }
}
// 实色底状态（单独定义，避免被渐变规则覆盖）
.status-ribbon.ribbon-unpaid {
  background: #ff4f4f;
}
.status-ribbon.ribbon-refunding {
  background: #ff831e;
}
.status-ribbon-text {
  position: absolute;
  left: 26px;
  top: 4px;
  width: 42px;
  font-size: 14px;
  font-weight: 700;
  line-height: 14px;
  text-align: center;
  white-space: nowrap;
}
</style>
